import styles from './partnersLoadingSkeleton.module.scss';

export const PartnersLoadingSkeleton = () => (
  <div
    className={styles.partnersLoadingSkeleton}
    data-testid='partners-loading-skeleton'
    aria-busy='true'
    aria-label='Loading project partners'
  >
    <div className={styles.headingRow}>
      <div className={styles.heading} aria-hidden='true' />
      <div className={styles.lastUpdate} aria-hidden='true' />
    </div>
    <div className={styles.subtitle} aria-hidden='true' />
    <div className={styles.cards}>
      {Array.from({ length: 3 }, (_, index) => (
        <div key={index} className={styles.card} data-testid='partner-card-skeleton' aria-hidden='true'>
          <span className={styles.picture} />
          <div className={styles.cardContent}>
            <span className={styles.name} />
            <span className={styles.label} />
            <span className={styles.value} />
          </div>
        </div>
      ))}
    </div>
  </div>
);
